export default __webpack_public_path__ + "static/hero_mobile-f1753987a564b9f8c592dc053b915924.webp";